import React, {useState, useEffect} from 'react'
import styled from "styled-components"
import {useDispatch} from "react-redux"
import {setFullScreen} from "../../actions/fullScreen"

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: transparent; /* Transparente para o vídeo aparecer ao fundo */
    z-index: 9999;
    display: flex;
    flex-direction: column;
    pointer-events: none; /* Deixa cliques passarem para o player se necessário */
`

const ControlsOverlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(transparent, rgba(0,0,0,0.9));
    padding: 40px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: opacity 0.5s;
    pointer-events: auto; /* Reativa cliques nos botões */
`

const Fullscreen = ({cTitle, cDesc}) => {
    const dispatch = useDispatch();
    const [showControls, setShowControls] = useState(true);

    useEffect(() => {
        let timer;
        const handleInteraction = () => {
            setShowControls(true);
            clearTimeout(timer);
            timer = setTimeout(() => setShowControls(false), 4000);
        };
        window.addEventListener('mousemove', handleInteraction);
        window.addEventListener('touchstart', handleInteraction);
        
        handleInteraction();

        return () => {
            window.removeEventListener('mousemove', handleInteraction);
            window.removeEventListener('touchstart', handleInteraction);
        };
    }, []);

    return (
        <Container>
            <div style={{flex: 1}}></div> {/* Espaço vazio para o vídeo */}
            
            <ControlsOverlay style={{opacity: showControls ? 1 : 0}}>
                <div>
                    <h2 style={{color: '#fff', margin: 0, fontWeight: 900, textTransform: 'uppercase'}}>{cTitle}</h2>
                    <p style={{color: '#aaa', margin: 0}}>{cDesc}</p>
                </div>
                <button 
                    className="btn btn-danger" 
                    style={{padding: '10px 30px', fontWeight: 'bold', borderRadius: '50px'}}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(setFullScreen(false));
                    }}
                >
                    <i className="fas fa-times"></i> FECHAR TELA CHEIA
                </button>
            </ControlsOverlay>
        </Container>
    )
}

export default Fullscreen;
